// extracted by mini-css-extract-plugin
export var select = "_qa-0";